<div class="row" *ngIf="!listo">
	<div class="spinner-container">
		<img src="Inmuebles/assets/iconos/spinner.gif">
	</div>
</div>

<div class="row" *ngIf="listo">
	<div class="inmuebles-content">
		<h2 class="inmuebles-titulo">{{ mensaje }}</h2>

		<div class="empty-container" *ngIf="inmuebles?.length == 0">
			<div class="empty-image-container">
				<img src="Inmuebles/assets/iconos/empty_state.svg" alt="Sin resultados" />
			</div>
			<div class="empty-text">
				<div class="empty-title">No se encontraron inmuebles con los datos seleccionados.</div>
				<div class="empty-subtitle">Te sugerimos ajustar los filtros de búsqueda para visualizar las opciones que buscas.</div>
			</div>
		</div>

		<div class="filas-inmuebles">
			<div class="fila-inmuebles" *ngFor="let fila of getFilasInmuebles()">
				<div class="card inmueble-card" *ngFor="let inmueble of fila">
					<img *ngIf="inmueble.imagenes?.length && inmueble.imagenes[0].principal == 1"
						[src]="inmueble.imagenes[0].ruta"
						(error)="inmueble.imagenes[0].ruta='Inmuebles/assets/img/nd_cards.svg'"
						class="card-img-top" alt="Imagen inmueble" />
					<img *ngIf="!inmueble.imagenes?.length" src="Inmuebles/assets/img/nd_cards.svg"
						class="card-img-top" alt="Sin imagen" />

					<div class="card-body">
						<label class="inmueble-desc">{{ inmueble.tipo }} en {{ inmueble.estado }} - {{ inmueble.ciudad }}</label>
						<label class="inmueble-price" *ngIf="inmueble.precio === 1">En actualización</label>
						<label class="inmueble-price" *ngIf="inmueble.precio !== 1">${{ inmueble.precio | number:'1.0-2' }} pesos</label>
						<div class="inmueble-datos">
							<label><b>Folio:</b> {{ inmueble.folio.slice(-5) }}</label>
							<label><b>Tipo:</b> {{ inmueble.tipo }}</label>
							<label><b>Subtipo:</b> {{ inmueble.subtipo }}</label>
							<label><b>Estado:</b> {{ inmueble.estado }}</label>
							<label *ngIf="inmueble.comercializable"><b>Estatus:</b> En venta</label>
							<label *ngIf="!inmueble.comercializable"><b>Estatus:</b> En regularización</label>
							<label><b>Dimensiones:</b> {{ inmueble.terreno | number:'1.0-2' }} m²</label>
						</div>
						<a (click)="detalleInmueble(inmueble.folio)" class="btn-detalle">Detalle de inmueble</a>
					</div>
				</div>
			</div>
		</div>

		<div class="paginador-wrapper" *ngIf="inmuebles?.length > 0">
			<div class="paginador-container">

				<div class="paginador-select">
					<label class="text-selectFilas" for="selectFilas">Filas por página</label>
					<select class="select-filas" id="selectFilas" [(ngModel)]="filasSeleccionadas"
						(change)="cambiarFilasPorPagina()">
						<option *ngFor="let filas of opcionesFilas" [value]="filas">{{ filas }}</option>
					</select>
				</div>

				<div class="paginador-rango">
					{{ desdeFila }}-{{ hastaFila }} de {{ totalFilas }}
				</div>

				<div class="paginador-botones">
					<button [disabled]="paginador.first" (click)="irPagina(0)">
						<img src="Inmuebles/assets/iconos/top-left.svg" alt="Primera página">
					</button>
					<button [disabled]="paginador.first" (click)="irPagina(paginador.number - 1)">
						<img src="Inmuebles/assets/iconos/left.svg" alt="Anterior">
					</button>
					<button [disabled]="paginador.last" (click)="irPagina(paginador.number + 1)">
						<img src="Inmuebles/assets/iconos/right.svg" alt="Siguiente">
					</button>
					<button [disabled]="paginador.last" (click)="irPagina(paginador.totalPages - 1)">
						<img src="Inmuebles/assets/iconos/top-right.svg" alt="Última página">
					</button>
				</div>

			</div>
		</div>
	</div>
</div>

<app-contactar-agente [detalle]="detalle" idTipoSolicitud="3" *ngIf="detalle"></app-contactar-agente>